import { $Qll } from '../utils/query-selector'
// import Swiper JS
import Swiper, { Navigation, Pagination, Autoplay, FreeMode } from "swiper";

/**
 * imports and determines slider parameters.
 *
 * @param object parameters of library https://swiperjs.com/swiper-api
 * 
 * @author Andres Briñez abrinez
 */

const configArrows = (id) => {
  new Swiper(id, {
    modules: [Navigation, Pagination, Autoplay, FreeMode],
    slidesPerView: "auto",
    spaceBetween: 20,
    keyboard: {
      enabled: true
    },
    navigation: {
      nextEl: `.swiper-button-next[data-id="${id.substr(1)}"]`,
      prevEl: `.swiper-button-prev[data-id="${id.substr(1)}"]`,
    },
    freeMode: true,
    breakpoints: {
      // when window width is >= 580px
      580: {
          slidesPerView: "auto",
          spaceBetweenSlides: 20
      },
      // when window width is >= 999px
      750: {
          slidesPerView: 2,
          spaceBetweenSlides: 20
      },
      1050: {
        slidesPerView: 3,
        spaceBetweenSlides: 20
      },
      1550: {
        slidesPerView: 4,
        spaceBetweenSlides: 20
      },
      2000: {
        slidesPerView: 5,
        spaceBetweenSlides: 20
      }
    }
  });
}

export const swiperArrows = (() => {
  $Qll(".collection-slider").map(slide => {
    configArrows('#' + slide.id)
  })
})();